module.exports = __webpack_public_path__ + "static/img/media_4.ffb42fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/media_4.png
// module id = OYm9
// module chunks = 1